// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-K2yT","type":"styles_type__2ERB6","choices":"styles_choices__1x3RC"};